// extracted by mini-css-extract-plugin
module.exports = {"member":"MemberCard_member__2tWDB"};